import React from 'react';
import { Modal } from './Modal';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
interface ContactModalProps {
  onClose: () => void;
}
export const ContactModal: React.FC<ContactModalProps> = ({
  onClose
}) => {
  return <Modal title="Contacto" onClose={onClose} data-id="element-104">
      <div className="space-y-6 text-gray-700" data-id="element-105">
        <p className="text-lg" data-id="element-106">
          Estamos aquí para ayudarte. No dudes en contactarnos si tienes alguna
          pregunta, sugerencia o necesitas asistencia con tu compra.
        </p>
        <div className="space-y-4" data-id="element-107">
          <div className="flex items-start gap-4" data-id="element-108">
            <div className="bg-teal-100 p-2 rounded-full" data-id="element-109">
              <MailIcon className="h-5 w-5 text-teal-600" data-id="element-110" />
            </div>
            <div data-id="element-111">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-112">
                Correo Electrónico
              </h3>
              <p className="text-gray-700" data-id="element-113">soporte@recetariofit.com</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-114">
                Respondemos en un plazo de 24-48 horas hábiles.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-115">
            <div className="bg-teal-100 p-2 rounded-full" data-id="element-116">
              <PhoneIcon className="h-5 w-5 text-teal-600" data-id="element-117" />
            </div>
            <div data-id="element-118">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-119">Teléfono</h3>
              <p className="text-gray-700" data-id="element-120">+54 11 1234-5678</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-121">
                Lunes a Viernes: 9:00 - 18:00 (Hora de Argentina)
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-122">
            <div className="bg-teal-100 p-2 rounded-full" data-id="element-123">
              <MapPinIcon className="h-5 w-5 text-teal-600" data-id="element-124" />
            </div>
            <div data-id="element-125">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-126">Ubicación</h3>
              <p className="text-gray-700" data-id="element-127">Buenos Aires, Argentina</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg mt-6" data-id="element-128">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-129">
            Envíanos un mensaje
          </h3>
          <form className="space-y-4" data-id="element-130">
            <div data-id="element-131">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-132">
                Nombre
              </label>
              <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500" placeholder="Tu nombre" data-id="element-133" />
            </div>
            <div data-id="element-134">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-135">
                Email
              </label>
              <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500" placeholder="tu@email.com" data-id="element-136" />
            </div>
            <div data-id="element-137">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-138">
                Mensaje
              </label>
              <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500" placeholder="¿En qué podemos ayudarte?" data-id="element-139" />
            </div>
            <button type="submit" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-6 rounded-md shadow transition duration-300" data-id="element-140">
              Enviar mensaje
            </button>
          </form>
        </div>
      </div>
    </Modal>;
};